export enum DeviceAccessModalTab {
  All = 'all',
  Collections = 'collections',
  Access = 'access',
}
